import { FilterFn } from "@tanstack/react-table";
import { defaultFilter } from "./defaultFilter";
import { strictEqualityFilter } from "./strictEqualityFilter";
import { dateFilter } from "./dateFilter";
import { moneyFilter } from "./moneyFilter";
import { cpuFilter } from "./cpuFilter";
import { tagFilter } from "./tagFilter";
import { accountDataFilter } from "./accountDataFilter";
import { labelFilter } from "./labelFilter";
import { createdByFilter } from "./createdByFilter";
import { providerUniqueIdentifierFilter } from "./providerUniqueIdentifierFilter";

export const normalizeString = (value: string): string => {
  value = value || "";
  return `${value}`.trim().toLowerCase();
};

const globalFilter: FilterFn<any> = (...props) => {
  const row = props[0];
  const columnId = props[1];
  const allColumns = row._getAllCellsByColumnId();
  const column = allColumns?.[columnId]?.column;
  const columnFilterFn = column.columnDef.filterFn;

  if (columnFilterFn && typeof columnFilterFn === "function") {
    return columnFilterFn(...props);
  }

  return (
    defaultFilter(...props) ||
    labelFilter(...props) ||
    strictEqualityFilter(...props) ||
    dateFilter(...props) ||
    moneyFilter(...props) ||
    cpuFilter(...props) ||
    tagFilter(...props) ||
    accountDataFilter(...props) ||
    createdByFilter(...props) ||
    providerUniqueIdentifierFilter(...props)
  );
};

export const filterFns = {
  tagFilter,
  defaultFilter,
  strictEqualityFilter,
  moneyFilter,
  dateFilter,
  cpuFilter,
  globalFilter,
  accountDataFilter,
  providerUniqueIdentifierFilter,
  createdByFilter,
  labelFilter,
};
